import { all, fork } from 'redux-saga/effects';

import watchSearchInfosRequest from './searchInfosRequest';
import watchSearchParam from './searchParam';
import watchSearchRequest from './searchRequest';
import watchSetSearchParams from './setSearchParams';

function* searchSagas() {
  yield all([
    fork(watchSearchRequest),
    fork(watchSearchInfosRequest),
    fork(watchSearchParam),
    fork(watchSetSearchParams),
  ]);
}

export default searchSagas;
